/*!

=========================================================
* Vision UI Free React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-free-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)
* Licensed under MIT (https://github.com/creativetimofficial/vision-ui-free-react/blob/master LICENSE.md)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// @mui material components
import { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import {
  AppBar,
  Card,
  Chip,
  CircularProgress,
  Divider,
  Tab,
  Tabs,
} from "@mui/material";

// Vision UI Dashboard React components
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import VuiProgress from "components/VuiProgress";

// Vision UI Dashboard React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// React icons

import { FaExternalLinkAlt} from "react-icons/fa";

import VuiInput from "components/VuiInput";

import GradientBorder from "examples/GradientBorder";

// Vision UI Dashboard assets

import VuiButton from "components/VuiButton";

import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { formatCurrency } from "utilities/utilites";
import { shortenAddress } from "utilities/utilites";
import { formatTimeDifference } from "utilities/utilites";
import MarketChart from "examples/Charts/MarketChart/MarketChart";
import { getChainIcon } from "utilities/utilites";
import { useBalance, useReadContract } from "wagmi";
import contractABI from "../../assets/contractABI.json";
import { useWallet } from "WalletProvider";
import { ethers } from "ethers";
import { getChainName } from "utilities/utilites";
import { calculateTVL } from "utilities/utilites";
import { writeContract } from "@wagmi/core";
import { config } from "index";
import { erc20Abi } from "viem";
import { ConnectKitButton } from "connectkit";
import MarketActivitySection from "./marketActivity";
import { Bounce, toast } from "react-toastify";
import axios from "axios";
import { LiFiModal } from "components/LiFiModal";

function MarketData() {
  const [marketTab, setMarketTab] = useState(0);

  const [mainTab, setMainTab] = useState(0); // PT (0) / YT (1)

  const { wallet, selectedChain } = useWallet();

  const { id } = useParams(); // Get ID from URL
  const [isLoading, setIsLoading] = useState(true);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [buyToken, setBuyToken] = useState(null);

  // Fixed handler functions
  const handleOpenModal = (market) => {
    // Return a function instead of immediately executing
    return () => {
      setBuyToken(market?.baseToken?.address);
      setIsModalOpen(true);
    };
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  

  // Retrieve markets from localStorage
  const { data: selectedMarket, isError } = useReadContract({
    abi: contractABI,
    address: process.env.REACT_APP_PROXY_CONTRACT_ADDRESS,
    functionName: "getMarket",
    args: [BigInt(id), BigInt(selectedChain)],
  });
  

  const { data: marketTVL } = useReadContract({
    abi: contractABI,
    address: process.env.REACT_APP_PROXY_CONTRACT_ADDRESS,
    functionName: "getTotalDepositsByMarket",
    args: [BigInt(id)],
  });
  
  

  // const markets = JSON.parse(localStorage.getItem("Markets")) || [];

  // Find the selected market
  // const selectedMarket = markets.find((market) => market.id === id);
  // 

  const [loading, setLoading] = useState(false);

  const [motherMarket, setMotherMarket] = useState(null);
  const [childMarket, setChildMarket] = useState(null);

  const [priceImpact, setPriceImpact] = useState(0);

  // const fetchOpenOceanPriceImpact = async (chain, fromToken, toToken, amount) => {
  //   try {
  //     const response = await fetch(
  //       `https://open-api.openocean.finance/v3/${chain}/quote?gasPrice=3&inTokenAddress=${fromToken}&outTokenAddress=${toToken}&amount=${amount}&slippage=1&account=0x929B44e589AC4dD99c0282614e9a844Ea9483aaa`,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );

  //     const data = await response.json();

  //     
  //     // return priceImpact;
  //     setPriceImpact(data?.data?.price_impact ?? "0%");
  //   } catch (error) {
  //     console.error("Error fetching price impact:", error);
  //   }
  // };

  const fetchTokenHolders = async (contractAddress, chainId) => {
    
    

    try {
      const response = await fetch(
        `https://api.chainbase.online/v1/token/holders?chain_id=${chainId}&contract_address=${contractAddress}`,
        {
          method: "GET",
          headers: {
            "x-api-key": "2tOuyOhPX3D1Y8E5lh9tsXxvfCC", // Replace with your actual API key
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();
      
      return data?.count || 0; // Returns the count of holders
    } catch (error) {
      console.error("Error fetching token holders:", error);
      return 0; // Fallback to 0 in case of an error
    }
  };

  const fetchLiFiRoute = async (requestBody) => {
    
    const lifiApiUrl = "https://li.quest/v1/quote"; // Li.Fi API endpoint
    const queryParams = new URLSearchParams(requestBody);
    
    try {
      const response = await fetch(`${lifiApiUrl}?${queryParams.toString()}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) throw new Error("Failed to fetch route");

      const data = await response.json();

      // Extract values
      const fromAmountUSD = parseFloat(data.estimate.fromAmountUSD);
      const toAmountUSD = parseFloat(data.estimate.toAmountUSD);

      // Calculate price impact
      const priceImpact = ((fromAmountUSD - toAmountUSD) / fromAmountUSD) * 100;

      return {
        fromAmountUSD,
        toAmountUSD,
        priceImpact: priceImpact.toFixed(2),
      };
    } catch (error) {
      console.error("Error fetching route:", error);
      return null;
    }
  };

  useEffect(() => {
    if (!selectedMarket?.motherChain || !selectedMarket?.motherPairAddress) return;

    const fetchMarketData = async () => {
      setLoading(true);

      try {
        const holdersCount = await fetchTokenHolders(
          selectedMarket?.motherToken,
          selectedMarket?.motherChain
        );
        

        const res = await fetch(
          `https://api.dexscreener.com/latest/dex/pairs/${getChainName(
            selectedMarket?.motherChain
          )}/${selectedMarket?.motherPairAddress}`
        );
        const data = await res.json();

        // Embed holders count into the token object
        const updatedToken = {
          ...data.pair,
          holdersCount,
        };
        setMotherMarket(updatedToken || null);
      } catch (error) {
        console.error("Error fetching market data:", error);
        setMotherMarket(null);
      } finally {
        setLoading(false);
      }
    };

    fetchMarketData();
  }, [selectedMarket?.motherChain, selectedMarket?.motherPairAddress]);

  useEffect(() => {
    if (!selectedMarket?.childChain || !selectedMarket?.childPairAddress) return;

    const fetchChildMarketData = async () => {
      setLoading(true);

      try {
        const holdersCount = await fetchTokenHolders(
          selectedMarket?.childToken,
          selectedMarket?.childChain
        );
        

        await fetchLiFiRoute({
          fromChain: selectedMarket?.childChain.toString(),
          fromToken: selectedMarket?.childToken,
          fromAmount: selectedMarket?.childTVL.toString(),
          toChain: selectedMarket?.motherChain.toString(),
          toToken: selectedMarket?.motherToken,
          fromAddress: process.env.REACT_APP_PROXY_CONTRACT_ADDRESS,
          toAddress: process.env.REACT_APP_PROXY_CONTRACT_ADDRESS,
        }).then((route) => {
          
          setPriceImpact(route ? route.priceImpact : "N/a");
        });

        // Embed holders count into the token object

        const res = await fetch(
          `https://api.dexscreener.com/latest/dex/pairs/${getChainName(
            selectedMarket?.childChain
          )}/${selectedMarket?.childPairAddress}`
        );
        const data = await res.json();
        const updatedToken = {
          ...data.pair,
          holdersCount,
        };

        setChildMarket(updatedToken || null);
      } catch (error) {
        console.error("Error fetching child market data:", error);
        setChildMarket(null);
      } finally {
        setLoading(false);
      }
    };

    fetchChildMarketData();
  }, [selectedMarket?.childChain, selectedMarket?.childPairAddress]);

  const [amount, setAmount] = useState(null);
  // const { write: deposit } = useContractWrite({
  //   address: contractAddress,
  //   abi,
  //   functionName: "deposit", // Your smart contract's deposit function
  // });

  const handleDeposit = async () => {
    
    
    if (!amount || parseFloat(amount) <= 0) {
      alert("Please enter a valid deposit amount.");
      return;
    }

    const isMotherToken = mainTab === 0; // Determine which token is being deposited

    try {
      setLoading(true); // Start loading
      if(isMotherToken){
        var parsedAmount = ethers.utils.parseUnits(amount, selectedMarket?.motherTokenDecimal === 0n ? 18 : selectedMarket?.motherTokenDecimal); // Convert amount to proper decimals

      }else{
        var parsedAmount = ethers.utils.parseUnits(amount, selectedMarket?.childTokenDecimal === 0n ? 18 : selectedMarket?.childTokenDecimal); // Convert amount to proper decimals
    
      }

   
      // Uncomment if using Wagmi:
      // 
      // console.log(isMotherToken)
      // console.log(childMarket)
      // console.log(motherMarket)
      // console.log( isMotherToken == false ? childMarket.baseToken.address : motherMarket.baseToken.address)
      if (childMarket?.baseToken.symbol == motherMarket?.baseToken.symbol) {
        toast.error("🦄 Mother & Child Tokens are the same!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
        return;
      }
      const maxAllowedTVL = isMotherToken ? selectedMarket.motherTVL : selectedMarket.childTVL;

      if (amount > maxAllowedTVL) {
        alert("Deposit Amount cannot be greater than the target TVL");
        return;
      }
      const fromChain = selectedChain;
      const fromToken = childMarket?.baseToken.address;
      const toChain = selectedChain;
      const toToken = motherMarket?.baseToken.address;
      const fromAmount = parsedAmount.toString();
      const fromAddress = process.env.REACT_APP_PROXY_CONTRACT_ADDRESS;
      const quote = await axios.get("https://li.quest/v1/quote", {
        params: {
          fromChain,
          toChain,
          fromToken,
          toToken,
          fromAmount,
          fromAddress,
        },
      });

      const approve = await writeContract(config, {
        abi: erc20Abi,
        address:
          isMotherToken == false ? childMarket.baseToken.address : motherMarket.baseToken.address,
        functionName: "approve",
        args: [process.env.REACT_APP_PROXY_CONTRACT_ADDRESS, parsedAmount + BigInt(1)],
      });
      
      
      
      const estimateamount = BigInt(quote?.data?.estimate?.toAmount) || BigInt(0);
      

      const message = await writeContract(config, {
        abi: contractABI,
        address: process.env.REACT_APP_PROXY_CONTRACT_ADDRESS,
        functionName: "deposit",
        args: [BigInt(id), parsedAmount, estimateamount, isMotherToken],
      });
      
      

      
      toast.success("🦄 Tokens Deposited successfully!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
      // Reset form after successful deposit
      setAmount(0);
      setLoading(false);
      // window.location.reload();
    } catch (error) {
      console.error("Deposit failed:", error);
      toast.error("🦄 Tokens deposited error!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    } finally {
      setLoading(false); // Stop loading
    }
  };

  
  const userMotherBalance = useBalance({
    address: wallet.address,
    token: motherMarket?.baseToken?.address,
  });
  

  const userChildBalance = useBalance({
    address: wallet.address,
    token: childMarket?.baseToken?.address,
  });
  console.log("TESTING TESTING")

  setTimeout(() => {
    setIsLoading(false);
  }, 2000);
  if (isLoading) {
    return (
      //  <CircularProgress color="primary" size={50} />
      <VuiBox
        top="50%"
        left="50%"
        transform="translate(-50%, -50%)"
        display="flex"
        justifyContent="center"
        alignItems="center"
        width="100%"
        height="100%"
        bgcolor="rgba(0,0,0,0.3)" // Optional dark overlay
        borderRadius="8px"
      >
        <CircularProgress color="primary" size={50} />
      </VuiBox>
    );
  }
  if (!selectedMarket) return <p>Failed to load market data.</p>;

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <VuiBox py={3}>
        {/* <Chip sx={"display:flex;float:right;marginBottom:2px"} size="small" label={selectedMarket?.status==0 ? "Active" : selectedMarket?.status==1 ? "Processing" : "Closed"}  color={selectedMarket?.status==0 ? "success" : selectedMarket?.status==1 ? "warning" : "error"}/> */}
        <Grid container spacing={3}>
          {/* Left Section: Form */}
          <Grid item xs={12} md={5}>
            <Card
              sx={{
                background: "rgba(19, 21, 34, 0.9)",
                borderRadius: "15px",
                overflow: "hidden",
                boxShadow: "0 8px 16px rgba(0, 0, 0, 0.3)",
              }}
            >
              {/* Main Tabs with Enhanced Styling */}
              <AppBar position="static" sx={{ background: "transparent", boxShadow: "none" }}>
                <Chip
                  sx={{
                    display: "flex",
                    float: "right",
                    marginBottom: "2px",
                    color: "white",
                  }}
                  size="medium"
                  label={
                    selectedMarket?.status === 0
                      ? `Market Active • created ${formatTimeDifference(
                          Number(selectedMarket?.createdAt)
                        )} ago`
                      : selectedMarket?.status === 1
                      ? `Market Merging`
                      : selectedMarket?.status === 2
                      ? `Market Closed • Merged ${formatTimeDifference(
                          Number(selectedMarket?.mergedAt)
                        )} ago`
                      : "Merging Failed: Retry processing"
                  }
                  color={
                    selectedMarket?.status === 0
                      ? "success"
                      : selectedMarket?.status === 1
                      ? "warning"
                      : selectedMarket?.status === 2
                      ? "error"
                      : "secondary"
                  }
                />

                <Tabs
                  value={mainTab}
                  onChange={(e, newVal) => setMainTab(newVal)}
                  sx={{
                    background: "transparent",
                    "& .MuiTabs-indicator": {
                      backgroundColor: "#1976d2",
                      height: "3px",
                    },
                  }}
                  variant="fullWidth"
                >
                  <Tab
                    label="Mother Token"
                    icon={
                      motherMarket?.info?.imageUrl ? (
                        <img
                          src={motherMarket?.info?.imageUrl}
                          width="20"
                          height="20"
                          alt="Mother Token"
                        />
                      ) : (
                        ""
                      )
                    }
                    iconPosition="start"
                    sx={{
                      color: mainTab === 0 ? "#fff" : "rgba(255, 255, 255, 0.7)",
                      fontWeight: mainTab === 0 ? "bold" : "normal",
                      transition: "all 0.3s",
                      "&:hover": { color: "#fff" },
                    }}
                  />
                  <Tab
                    label="Child Token"
                    icon={
                      childMarket?.info?.imageUrl ? (
                        <img
                          src={childMarket?.info?.imageUrl}
                          width="20"
                          height="20"
                          alt="Child Token"
                        />
                      ) : (
                        ""
                      )
                    }
                    iconPosition="start"
                    sx={{
                      color: mainTab === 1 ? "#fff" : "rgba(255, 255, 255, 0.7)",
                      fontWeight: mainTab === 1 ? "bold" : "normal",
                      transition: "all 0.3s",
                      "&:hover": { color: "#fff" },
                    }}
                  />
                </Tabs>
              </AppBar>

              <Divider light sx={{ opacity: 0.2 }} />

              {/* Form Content */}
              <VuiBox p={3}>
                <VuiBox
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mb: 2,
                    background: "rgba(0, 0, 0, 0.2)",
                    p: 2,
                    borderRadius: "10px",
                  }}
                >
                  <VuiBox
                    component="div"
                    sx={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      background: "linear-gradient(310deg, #2152ff 0%, #21d4fd 100%)",
                      mr: 2,
                    }}
                  >
                    {mainTab === 0
                      ? motherMarket?.baseToken?.name?.charAt(0) || "M"
                      : childMarket?.baseToken?.name?.charAt(0) || "C"}
                  </VuiBox>
                  <VuiBox flex={1}>
                    <VuiTypography variant="button" color="text" fontWeight="medium">
                      Selected Token
                    </VuiTypography>
                    <VuiTypography variant="h6" color="white">
                      {mainTab === 0
                        ? motherMarket?.baseToken?.name || "Mother Token"
                        : childMarket?.baseToken?.name || "Child Token"}
                    </VuiTypography>
                    <VuiTypography variant="caption" color="text" fontWeight="medium">
                      Actual / Target Deposits:
                    </VuiTypography>
                    <VuiTypography variant="h6" color="white">
                      {mainTab === 0
                        ? `${parseFloat(ethers.utils.formatUnits(marketTVL[0],selectedMarket?.motherTokenDecimal === 0n ? 18 : selectedMarket?.motherTokenDecimal)).toFixed(2)} / ${
                            parseFloat(ethers.utils.formatUnits(selectedMarket?.motherTVL,selectedMarket?.motherTokenDecimal === 0n ? 18 : selectedMarket?.motherTokenDecimal)).toFixed(
                              2
                            ) || "0"
                          } ${motherMarket?.baseToken?.symbol || ""}`
                        : `${parseFloat(ethers.utils.formatUnits(marketTVL[1],selectedMarket?.childTokenDecimal === 0n ? 18 : selectedMarket?.childTokenDecimal)).toFixed(2)} / ${
                            parseFloat(ethers.utils.formatUnits(selectedMarket?.childTVL,selectedMarket?.childTokenDecimal === 0n ? 18 : selectedMarket?.childTokenDecimal)).toFixed(
                              2
                            ) || "0"
                          } ${motherMarket?.baseToken?.symbol || ""}`}
                    </VuiTypography>
                  </VuiBox>
                </VuiBox>

                <VuiBox mb={3}>
                  <VuiTypography
                    variant="button"
                    color="text"
                    fontWeight="medium"
                    mb={1}
                    display="block"
                  >
                    Amount to Deposit
                  </VuiTypography>
                  <GradientBorder padding="1px" borderRadius="10px">
                    <VuiInput
                      fullWidth
                      type="number"
                      name="amount"
                      placeholder={`Enter ${mainTab === 0 ? "Mother" : "Child"} token amount...`}
                      variant="outlined"
                      value={amount}
                      onChange={(e) => setAmount(e.target.value)}
                      sx={{ height: "45px" }}
                    />
                  </GradientBorder>

                  {/* Display the amount & USD equivalent dynamically */}
                  {amount && (
                    <VuiTypography variant="caption" color="info" mt={1}>
                      {`≈ $${(
                        amount *
                        (mainTab === 0 ? motherMarket?.priceUsd : childMarket?.priceUsd || 0)
                      ).toFixed(2)} USD`}
                    </VuiTypography>
                  )}

                  {mainTab === 0 && userMotherBalance?.data && (
                    <VuiBox display="flex" justifyContent="space-between" mt={1}>
                      <VuiTypography variant="caption" color="text">
                        Balance:{" "}
                        {parseFloat(
                          ethers.utils.formatUnits(
                            userMotherBalance.data.value,
                            userMotherBalance.data.decimals
                          )
                        ).toFixed(2)}{" "}
                        {motherMarket?.baseToken?.symbol}
                        
                      </VuiTypography>
                      {userMotherBalance.data.value == 0 ? (
                        <VuiButton
                          variant="contained"
                          type="button"
                          onClick={() => handleOpenModal(motherMarket)()}
                          disabled={selectedMarket?.status > 0}
                          sx={{
                            py: 1.5,
                            background:
                              mainTab === 0
                                ? "linear-gradient(310deg, #2152ff 0%, #21d4fd 100%)"
                                : "linear-gradient(310deg, #17ad37 0%, #98ec2d 100%)",
                            boxShadow:
                              mainTab === 0
                                ? "0 0 10px rgba(33, 82, 255, 0.5)"
                                : "0 0 10px rgba(23, 173, 55, 0.5)",
                            transition: "all 0.2s",
                            "&:hover": {
                              transform: "translateY(-2px)",
                              boxShadow:
                                mainTab === 0
                                  ? "0 5px 15px rgba(33, 82, 255, 0.6)"
                                  : "0 5px 15px rgba(23, 173, 55, 0.6)",
                            },
                          }}
                        >
                          Buy {motherMarket?.baseToken?.symbol}
                        </VuiButton>
                      ) : (
                        <VuiTypography
                          variant="caption"
                          color="info"
                          sx={{ cursor: "pointer" }}
                          onClick={() =>
                            setAmount(
                              ethers.utils.formatUnits(
                                userMotherBalance.data.value,
                                userMotherBalance.data.decimals
                              )
                            )
                          }
                        >
                          MAX
                        </VuiTypography>
                      )}
                    </VuiBox>
                  )}

                  {mainTab === 1 && userChildBalance?.data && (
                    <VuiBox display="flex" justifyContent="space-between" mt={1}>
                      <VuiTypography variant="caption" color="text">
                        Balance:{" "}
                        {parseFloat(
                          ethers.utils.formatUnits(
                            userChildBalance.data.value,
                            userChildBalance.data.decimal
                          )
                        ).toFixed(2)}{" "}
                        {childMarket?.baseToken?.symbol}
                      </VuiTypography>
                      {userChildBalance.data.value == 0 ? (
                  
                        <VuiButton
                          variant="contained"
                          type="button"
                          onClick={() => handleOpenModal(childMarket)()}
                          disabled={selectedMarket?.status > 0}
                          sx={{
                            py: 1.5,
                            background:
                              mainTab === 1
                                ? "linear-gradient(310deg, #2152ff 0%, #21d4fd 100%)"
                                : "linear-gradient(310deg, #17ad37 0%, #98ec2d 100%)",
                            boxShadow:
                              mainTab === 1
                                ? "0 0 10px rgba(33, 82, 255, 0.5)"
                                : "0 0 10px rgba(23, 173, 55, 0.5)",
                            transition: "all 0.2s",
                            "&:hover": {
                              transform: "translateY(-2px)",
                              boxShadow:
                                mainTab === 1
                                  ? "0 5px 15px rgba(33, 82, 255, 0.6)"
                                  : "0 5px 15px rgba(23, 173, 55, 0.6)",
                            },
                          }}
                        >
                          Buy {childMarket?.baseToken?.symbol}
                        </VuiButton>
                      ) : (
                        <VuiTypography
                          variant="caption"
                          color="info"
                          sx={{ cursor: "pointer" }}
                          onClick={() =>
                            setAmount(
                              ethers.utils.formatUnits(
                                userChildBalance.data.value,
                                userChildBalance.data.decimal
                              )
                            )
                          }
                        >
                          MAX
                        </VuiTypography>
                      )}
                    </VuiBox>
                  )}
                </VuiBox>
                {wallet.address ? (
                  <VuiButton
                    variant="contained"
                    color={mainTab === 0 ? "info" : "success"}
                    type="button"
                    onClick={handleDeposit}
                    disabled={
                      selectedMarket?.status > 0 ||
                      (mainTab === 0
                        ? marketTVL[0] >= selectedMarket?.motherTVL
                        : marketTVL[1] >= selectedMarket?.childTVL)
                    }
                    sx={{
                      py: 1.5,
                      background:
                        mainTab === 0
                          ? "linear-gradient(310deg, #2152ff 0%, #21d4fd 100%)"
                          : "linear-gradient(310deg, #17ad37 0%, #98ec2d 100%)",
                      boxShadow:
                        mainTab === 0
                          ? "0 0 10px rgba(33, 82, 255, 0.5)"
                          : "0 0 10px rgba(23, 173, 55, 0.5)",
                      transition: "all 0.2s",
                      "&:hover": {
                        transform: "translateY(-2px)",
                        boxShadow:
                          mainTab === 0
                            ? "0 5px 15px rgba(33, 82, 255, 0.6)"
                            : "0 5px 15px rgba(23, 173, 55, 0.6)",
                      },
                    }}
                  >
                    Deposit {mainTab === 0 ? "Mother Token" : "Child Token"}
                  </VuiButton>
                ) : (
                  <VuiBox sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
                    <ConnectKitButton theme="soft" label="Connect to Merge" />
                  </VuiBox>
                )}
              </VuiBox>
            </Card>
          </Grid>

          {/* Right Section: Market Info & Charts */}
          <Grid item xs={12} md={7}>
            <Card sx={{}}>
              <AppBar position="static">
                <Tabs
                  value={marketTab}
                  onChange={(e, newVal) => setMarketTab(newVal)}
                  sx={{ background: "transparent" }}
                >
                  <Tab label="Market Info" />
                  <Tab label="Charts" />
                </Tabs>
              </AppBar>

              <VuiBox>
                {marketTab === 0 ? (
                  <Card sx={{ overflow: "hidden" }}>
                    {/* Card Header */}
                    <VuiBox p={3} pb={1}>
                      <VuiBox display="flex" justifyContent="space-between" alignItems="center">
                        <VuiBox>
                          <VuiTypography
                            variant="lg"
                            color="white"
                            fontWeight="bold"
                            display="block"
                          >
                            {selectedMarket?.name}
                          </VuiTypography>
                          <VuiTypography
                            variant="caption"
                            color="text"
                            fontWeight="regular"
                            display="block"
                            mt={0.5}
                          >
                            {formatTimeDifference(Number(selectedMarket?.createdAt))}
                          </VuiTypography>
                        </VuiBox>

                        <VuiBox
                          display="flex"
                          alignItems="center"
                          px={2}
                          py={1}
                          borderRadius="8px"
                          sx={{ backgroundColor: "#29549d" }}
                        >
                          <Icon sx={{ color: "white", fontSize: 18, mr: 1 }}>content_copy</Icon>
                          <VuiTypography
                            variant="caption"
                            fontWeight="bold"
                            color="white"
                            sx={{ cursor: "pointer" }}
                            onClick={() => navigator.clipboard.writeText(selectedMarket?.creator)}
                          >
                            Creator: {shortenAddress(selectedMarket?.creator)}
                          </VuiTypography>
                        </VuiBox>
                      </VuiBox>

                      {/* Key Metrics */}
                      <VuiBox
                        mt={2}
                        p={2}
                        borderRadius="lg"
                        sx={{ backgroundColor: "rgba(39, 102, 168, 0.2)" }}
                      >
                        <Grid container spacing={2}>
                          <Grid item xs={12} md={12}>
                            <VuiBox display="flex" justifyContent="space-between">
                              <VuiTypography variant="button" color="white" fontWeight="regular">
                                Price Impact post Merge:
                              </VuiTypography>
                              <VuiTypography
                                variant="button"
                                color="white"
                                fontWeight="bold"
                                sx={{ fontSize: "20px" }}
                              >
                                ~ {priceImpact}%
                              </VuiTypography>
                            </VuiBox>
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <VuiBox display="flex" justifyContent="space-between">
                              <VuiTypography variant="caption" color="white" fontWeight="regular">
                                Mother TVL Target:
                              </VuiTypography>
                              <VuiTypography variant="caption" color="white" fontWeight="medium">
                                {ethers.utils.formatUnits(selectedMarket?.motherTVL,selectedMarket?.motherTokenDecimal === 0n ? 18 : selectedMarket?.motherTokenDecimal)}{" "}
                                {motherMarket?.baseToken?.symbol}
                              </VuiTypography>
                            </VuiBox>
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <VuiBox display="flex" justifyContent="space-between">
                              <VuiTypography variant="caption" color="white" fontWeight="regular">
                                Child TVL Target:
                              </VuiTypography>
                              <VuiTypography variant="caption" color="white" fontWeight="medium">
                                {ethers.utils.formatUnits(selectedMarket?.childTVL,selectedMarket?.childTokenDecimal === 0n ? 18 : selectedMarket?.childTokenDecimal)}{" "}
                                {childMarket?.baseToken?.symbol}
                              </VuiTypography>
                            </VuiBox>
                          </Grid>
                        </Grid>
                      </VuiBox>
                    </VuiBox>

                    {/* Market Cards */}
                    <VuiBox px={3} pb={3}>
                      <Grid container spacing={3}>
                        {/* Mother Token Card */}
                        <Grid item xs={12} md={6}>
                          <MarketCard
                            title="Mother Token"
                            market={motherMarket}
                            tvlValue={calculateTVL(selectedMarket?.motherTVL, marketTVL[0])}
                            tvlColor="success"
                            getChainIcon={getChainIcon}
                            formatCurrency={formatCurrency}
                            shortenAddress={shortenAddress}
                          />
                        </Grid>

                        {/* Child Token Card */}
                        <Grid item xs={12} md={6}>
                          <MarketCard
                            title="Child Token"
                            market={childMarket}
                            tvlValue={calculateTVL(selectedMarket?.motherTVL, marketTVL[1])}
                            tvlColor="error"
                            getChainIcon={getChainIcon}
                            formatCurrency={formatCurrency}
                            shortenAddress={shortenAddress}
                          />
                        </Grid>
                      </Grid>
                    </VuiBox>
                  </Card>
                ) : (
                  <VuiBox sx={{ height: "510px", marginTop: 5 }}>
                    <MarketChart motherTokenData={motherMarket} childTokenData={childMarket} />
                    {/* <TradingViewWidget /> */}

                    {/* <LineChart
                      lineChartData={lineChartDataDashboard}
                      lineChartOptions={lineChartOptionsDashboard}
                    /> */}
                  </VuiBox>
                )}
              </VuiBox>
            </Card>

            {/* My Positions & Market Transactions */}
            {/* <Card sx={{ mt: 3 }}>
              <AppBar position="static">
                <Tabs
                  value={transactionsTab}
                  onChange={(e, newVal) => setTransactionsTab(newVal)}
                  sx={{ background: "transparent" }}
                >
                  <Tab label="My Positions" />
                  <Tab label="Market Transactions" />
                </Tabs>
              </AppBar>
              <VuiBox>
                  <VuiBox mb={3}>
                    <VuiBox
                      sx={{
                        "& th": {
                          borderBottom: ({ borders: { borderWidth }, palette: { grey } }) =>
                            `${borderWidth[1]} solid ${grey[700]}`,
                        },
                        "& .MuiTableRow-root:not(:last-child)": {
                          "& td": {
                            borderBottom: ({ borders: { borderWidth }, palette: { grey } }) =>
                              `${borderWidth[1]} solid ${grey[700]}`,
                          },
                        },
                      }}
                    >
                      <Table columns={prCols} rows={marketTx} />
                    </VuiBox>
                  </VuiBox>
                
              </VuiBox>
            </Card> */}
            <MarketActivitySection
              marketId={id}
              selectedMarket={selectedMarket}
              motherMarket={motherMarket}
              childMarket={childMarket}
            />
          </Grid>

{/* Modal */}
<LiFiModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        buyToken={buyToken}
      />
          {/* <VuiBox p={2}>
            <Modal
              open={isModalOpen}
              onClose={() => !isLoading && setIsModalOpen(false)}
              aria-labelledby="withdraw-modal-title"
              aria-describedby="withdraw-modal-description"
            >
              <Box
                tabIndex={-1}
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: 400,
                  maxWidth: "90%",
                  bgcolor: "background.paper",
                  background: "rgba(19, 21, 34, 0.95)",
                  border: "1px solid rgba(255, 255, 255, 0.1)",
                  borderRadius: "15px",
                  boxShadow: 24,
                  outline: "none",
                }}
              >
                <VuiBox p={3}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mb: 2,
                    }}
                  >
                    <h2 id="withdraw-modal-title" style={{ margin: 0, color: "white" }}>
                      Swap Tokens
                    </h2>
                    <button
                      onClick={() => !isLoading && setIsModalOpen(false)}
                      style={{
                        background: "none",
                        border: "none",
                        color: "white",
                        fontSize: "1.5rem",
                        cursor: "pointer",
                      }}
                    >
                      ×
                    </button>
                  </Box>

                  <SwapWidget
                    tokenList="https://ipfs.io/ipns/tokens.uniswap.org"
                    provider={provider}
                    jsonRpcUrlMap={jsonRpcUrlMap}
                    defaultOutputTokenAddress={buyToken}
                    onSwapStart={() => setIsLoading(true)}
                    onSwapComplete={() => setIsLoading(false)}
                  />
                </VuiBox>
              </Box>
            </Modal>
          </VuiBox> */}
        </Grid>
      </VuiBox>
      <Footer />
    </DashboardLayout>
  );
}

// Extracted market card component for better organization
const MarketCard = ({
  title,
  market,
  tvlValue,
  tvlColor,
  getChainIcon,
  formatCurrency,
  shortenAddress,
}) => {
  return (
    <VuiBox
      display="flex"
      flexDirection="column"
      p={3}
      sx={{
        background:
          "linear-gradient(135deg, rgba(39, 102, 168, 0.6) 0%, rgba(39, 102, 168, 0.8) 100%)",
        borderRadius: "16px",
        boxShadow: "0 8px 16px rgba(0, 0, 0, 0.15)",
      }}
    >
      {/* Card Header with Title */}
      <VuiBox display="flex" alignItems="center" mb={2}>
        <VuiTypography variant="subtitle2" fontWeight="bold" color="white">
          {title}
        </VuiTypography>
      </VuiBox>

      {/* Token Details Header */}
      <VuiBox
        display="flex"
        alignItems="center"
        mb={3}
        pb={2}
        sx={{ borderBottom: "1px solid rgba(255, 255, 255, 0.1)" }}
      >
        {/* Chain & DEX */}
        <VuiBox display="flex" flexDirection="column" alignItems="center" mr={2}>
          {getChainIcon(market?.chainId)}
          <VuiBox mt={0.5}>
            <img
              src={`https://dd.dexscreener.com/ds-data/dexes/${market?.dexId}.png`}
              width={20}
              height={20}
              alt={market?.dexId}
            />
          </VuiBox>
        </VuiBox>

        {/* Token Icon */}
        <VuiBox
          display="flex"
          justifyContent="center"
          alignItems="center"
          width={48}
          height={48}
          borderRadius="50%"
          bgcolor="white"
          mr={2}
        >
          {market?.info?.imageUrl ? (
            <VuiBox
              component="img"
              src={market?.info?.imageUrl}
              width="100%"
              height="100%"
              borderRadius="50%"
            />
          ) : (
            <VuiTypography variant="body2" color="text">
              ?
            </VuiTypography>
          )}
        </VuiBox>

        {/* Token Name & Link */}
        <VuiBox flexGrow={1} minWidth={0}>
          {" "}
          {/* Ensures it can shrink */}
          <VuiTypography
            variant="button"
            fontWeight="bold"
            color="white"
            sx={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "block",
            }}
          >
            {`${market?.baseToken?.symbol} / ${market?.quoteToken?.symbol}`}
          </VuiTypography>
          <VuiBox display="flex" alignItems="center" minWidth={0}>
            <VuiTypography
              variant="caption"
              color="text"
              mr={1}
              sx={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "100%",
                display: "block",
              }}
            >
              {market?.baseToken?.name}
            </VuiTypography>
            <a
              href={market?.url}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "white" }}
              onClick={(e) => e.stopPropagation()}
            >
              <FaExternalLinkAlt size={12} />
            </a>
          </VuiBox>
        </VuiBox>
      </VuiBox>

      {/* Market Metrics */}
      <Grid container spacing={2}>
        {/* Left Column */}
        <Grid item xs={6}>
          <MetricItem label="Mcap" value={`~${formatCurrency(market?.marketCap)}`} />
          <MetricItem label="Liquidity" value={`~${formatCurrency(market?.liquidity?.usd)}`} />
          <MetricItem label="Holders" value={`~${market?.holdersCount}`} />
          <MetricItem label="Chain" value={market?.chainId} />
          <MetricItem label="Dex" value={market?.dexId} />
        </Grid>

        {/* Right Column */}
        <Grid item xs={6}>
          {/* Token Address */}
          <VuiBox mb={6}>
            <VuiTypography variant="caption" color="text" mb={0.5} display="block">
              Token Address
            </VuiTypography>
            <VuiBox
              display="flex"
              alignItems="center"
              px={1.5}
              py={1}
              borderRadius="8px"
              sx={{
                backgroundColor: "rgba(255, 255, 255, 0.1)",
                cursor: "pointer",
              }}
              onClick={(e) => {
                navigator.clipboard.writeText(market?.baseToken?.address);
                e.stopPropagation();
              }}
            >
              <Icon sx={{ color: "white", fontSize: 5, mr: 0.5 }}>content_copy</Icon>
              <VuiTypography variant="caption" fontWeight="bold" color="white">
                {shortenAddress(market?.baseToken?.address)}
              </VuiTypography>
            </VuiBox>
          </VuiBox>

          {/* Pair Address */}
          <VuiBox mb={2}>
            <VuiTypography variant="caption" color="text" mb={0.5} display="block">
              Pair Address
            </VuiTypography>
            <VuiBox
              display="flex"
              alignItems="center"
              px={1.5}
              py={1}
              borderRadius="8px"
              sx={{
                backgroundColor: "rgba(255, 255, 255, 0.1)",
                cursor: "pointer",
              }}
              onClick={() => navigator.clipboard.writeText(market?.pairAddress)}
            >
              <Icon sx={{ color: "white", fontSize: 5, mr: 0.5 }}>content_copy</Icon>
              <VuiTypography variant="caption" fontWeight="bold" color="white">
                {shortenAddress(market?.pairAddress)}
              </VuiTypography>
            </VuiBox>
          </VuiBox>
        </Grid>
      </Grid>

      {/* TVL Progress */}
      <VuiBox mt={2}>
        <VuiTypography variant="caption" color="text" mb={1} display="block">
          Locked (TVL):
        </VuiTypography>
        <VuiProgress
          value={tvlValue}
          label
          color={tvlColor}
          sx={{ background: "rgba(45, 46, 95, 0.5)" }}
        />
      </VuiBox>
    </VuiBox>
  );
};

// Helper component for consistent metric display
const MetricItem = ({ label, value }) => (
  <VuiBox display="flex" justifyContent="space-between" alignItems="center" mb={2.5}>
    <VuiTypography variant="caption" color="text">
      {label}
    </VuiTypography>
    <VuiTypography variant="caption" fontWeight="bold" color="white">
      {value}
    </VuiTypography>
  </VuiBox>
);

export default MarketData;
